import React from 'react';

import GetRegions from '@src/api/GetRegions';
import useAxiosErrorHandler from '@src/hooks/useAxiosErrorHandler';
import useAxiosRequestConfig from '@src/hooks/useAxiosRequestConfig';
import useIsMounted from '@src/hooks/useIsMounted';

export type Region = {
  name: string;
  code: string;
};

const useRegions = () => {
  const axiosRequestConfig = useAxiosRequestConfig();
  const axiosErrorHandler = useAxiosErrorHandler();
  const [data, setData] = React.useState<Region[]>([]);
  const [loading, setLoading] = React.useState(true);
  const isMounted = useIsMounted();

  const makeRequest = React.useCallback(async () => {
    try {
      setLoading(true);
      const response = await GetRegions(axiosRequestConfig);
      setData(
        response.data.regions.map((region) => ({
          name: region.name,
          code: region.code,
        }))
      );
      setLoading(false);
    } catch (e) {
      if (isMounted) {
        setLoading(false);
      }
      axiosErrorHandler(e);
    }
  }, [axiosErrorHandler, axiosRequestConfig, isMounted]);

  React.useEffect(() => {
    makeRequest().catch(console.log);
  }, [makeRequest]);

  return React.useMemo(() => ({ data, loading }), [data, loading]);
};

export default useRegions;
